import React from "react";
import { classnames, isNonEmptyString } from "../../../utils";
import IconRegistry from "./icon-registry";
import * as styles from "./icon.module.scss";

export type IconName = keyof typeof IconRegistry;

export type IconSize = "s" | "m" | "l" | "xl" | "xxl" | "xxxl" | "socials";

export interface IconProps extends Omit<React.SVGAttributes<HTMLOrSVGElement>, "name"> {
  name: IconName;
  size?: IconSize | undefined;
}

export const Icon = ({ className, name, size, ...otherProps }: IconProps) => {
  const Component = IconRegistry[name];
  return !Component ? null : (
    <Component
      // The asset SVGs carry role="img" but no <title>, so without this every icon is an
      // unnamed image to a screen reader. They all sit next to their own label, so they are
      // decorative. An icon that is the only content of a control gets its name from an
      // aria-label on that control (see button.tsx callers), not from the icon.
      aria-hidden="true"
      {...otherProps}
      className={classnames({
        [`${className}`]: !!className,
        [styles.base]: true,
        [styles[size as string]]: isNonEmptyString(size) && styles[size as string] !== undefined,
      })}
    />
  );
};
